import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "product-card__title",
  "data-eq-part": "product-card__title"
}
const _hoisted_2 = { class: "product-card__title-name" }
const _hoisted_3 = { class: "product-card__title-slogan" }

import Product from '@/classes/Product';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardTitle',
  props: {
    product: {}
  },
  setup(__props: any) {

const props = __props;

const hasCategoryImage = computed(() => !!props.product.category.image?.url);

return (_ctx: any,_cache: any) => {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (hasCategoryImage.value)
        ? (_openBlock(), _createBlock(_component_LazyBackgroundMedia, {
            key: 0,
            class: "product-card__title-icon",
            icon: "",
            "media-url": _ctx.product.category.image?.url,
            "background-position-y": "center",
            "background-position-x": "center",
            "no-repeat": ""
          }, null, 8, ["media-url"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.product.name), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.product.slogan || '## Slogan ##'), 1)
    ])
  ]))
}
}

})